import type { JSX } from 'react';
import { MAX_SCORE, MIN_SCORE, type Score } from '@fatigue/shared';

/**
 * Fourteen points of shape, no axes and no labels.
 *
 * It exists to help a clinician pick a patient out of the list, not to be read
 * as a measurement — the real chart is one click away, and every row also
 * carries the last level by name.
 */
export function Sparkline({ scores }: { readonly scores: readonly Score[] }): JSX.Element | null {
  if (scores.length < 2) return null;

  const w = 64;
  const h = 22;
  const step = w / (scores.length - 1);

  const points = scores
    .map((score, i) => {
      const y = 1 + ((MAX_SCORE - score) / (MAX_SCORE - MIN_SCORE)) * (h - 2);
      return `${(i * step).toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <svg width={w} height={h} aria-hidden="true" className="spark">
      <polyline points={points} fill="none" stroke="currentColor" strokeWidth={1.5} />
    </svg>
  );
}
